import type { Station } from "./protocol";

/**
 * The Czech names of what a device stands for (AGENTS.md glossary), one
 * copy for both apps: the organizer's „Zařízení" page and the hall app say
 * the same thing about the same device.
 */

/** A device function (live.Function*). */
export type DeviceFunction =
  | "moderator"
  | "head_judge"
  | "checkin"
  | "it"
  | "debug";

export const DEVICE_FUNCTION_LABELS: Record<DeviceFunction, string> = {
  moderator: "Moderátor",
  head_judge: "Předseda poroty",
  checkin: "Prezence",
  it: "IT",
  debug: "Ladicí zařízení",
};

/** A judge's seat kind at a table. */
export const STATION_KIND_LABELS: Record<Station["seat_kind"], string> = {
  plus: "Plusový porotce",
  tech: "Technický porotce",
};

/** „Plusový porotce 2", a seat without its table. */
export function seatLabel(s: { kind: Station["seat_kind"]; position: number }): string {
  return `${STATION_KIND_LABELS[s.kind]} ${s.position}`;
}

/** „Stůl 1 · Plusový porotce 2". */
export function stationLabel(s: Station): string {
  return `Stůl ${s.table} · ${STATION_KIND_LABELS[s.seat_kind]} ${s.seat_position}`;
}

/** What a paired device stands for, for a heading. */
export function deviceRole(d: {
  station?: Station | null;
  function?: string;
}): string {
  if (d.station) return stationLabel(d.station);
  return (
    DEVICE_FUNCTION_LABELS[d.function as DeviceFunction] ?? d.function ?? ""
  );
}
